import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import IProduct from '@meronex/icons/fi/FiPackage';
import { App } from '@meronex/app';
import Switch from '@material-ui/core/Switch';

import { useTheme } from '@material-ui/core/styles';
import Quantity from '../../../common/Quantity';
import SitesAvatar from '../../../common/SitesAvatar';

import StoreItemProducts from './StoreItemProductsDialog';
import StoreItemDetailsFields from './StoreItemDetailsFields';

function StoreItemDetails(props) {
  const {
    item,
    products,
    showDetails,
    onGroupsCountClick,
    showStore,
    showTransaction,
    showBatches,
    permissions,
    showUpdated,
    showFactory,
    showId,
    onToggleActive,
  } = props;

  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const [openStoreItemProducts, setOpenStoreItemProducts] = React.useState();
  const [isActive, setIsActive] = React.useState(item?.isActive);
  const [currentThreshold, setCurrentThreshold] = React.useState(item?.lowStockThreshold || 0);

  React.useEffect(() => {
    // Update isActive when item changes
    setIsActive(item?.isActive !== false);
    setCurrentThreshold(item?.lowStockThreshold || 0);
  }, [item]);

  const handleToggle = (e) => {
    const newIsActive = e.target.checked;
    setIsActive(newIsActive);
    if (onToggleActive) {
      onToggleActive(item._id, newIsActive);
    }
  };

  if (!item || typeof item.type !== 'object') {
    return null;
  }
  const name = item.type.name;
  const imgSrc = (item.type.image || {}).thumbUrl;
  const unitLabel = item.type.unit;
  const quantity = item.quantity;

  const renderBatchInfo = () => {
    if (
      item &&
      item.productionInfo &&
      item.productionInfo.product &&
      item.productionInfo.product.groupByBatch &&
      Array.isArray(item.itemGroups) &&
      item.itemGroups.length > 0
    ) {
      return (
        <div className={'noselect'}>
          <div
            onClick={() => {
              if (typeof onGroupsCountClick === 'function') {
                onGroupsCountClick();
              }
            }}
            style={{
              top: '66px',
              height: '50px',
              fontSize: '12px',
              right: '20px',
              color: onGroupsCountClick ? 'rgb(85, 108, 214)' : 'gray',
              cursor: onGroupsCountClick ? 'pointer' : '',
            }}>
            <span
              style={{
                position: 'relative',
                top: '20px',
              }}>
              {item.itemGroups.length} batches
            </span>
          </div>
        </div>
      );
    }
  };

  const renderPackaging = () => {
    if (
      item.productionInfo &&
      item.productionInfo.product &&
      item.productionInfo.product.packaging
    ) {
      const unit = item.productionInfo.product.packaging.unit;
      const rate = item.productionInfo.product.packaging.rate || 1;

      return (
        <div
          style={{
            color: 'gray',
            fontSize: '12px',
            marginTop: '5px',
          }}>
          {App.utils.number.round(quantity / rate)} {unit}
        </div>
      );
    }
    return null;
  };
  const isMobile = App.utils.isMobile();
  const hasThreshold = currentThreshold > 0;
  const isOutOfStock = quantity === 0;
  const isLowStock = hasThreshold && quantity > 0 && quantity <= currentThreshold;
  const showStockPill = hasThreshold || isOutOfStock;

  return (
    <>
      <div style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
        <div style={{ display: 'table-row' }}>
          {/* Thumbnail */}
          <div style={{ display: 'table-cell', width: '68px', verticalAlign: 'top', paddingRight: '12px' }}>
            <SitesAvatar
              image={imgSrc}
              name={item.type.name}
              size={56}
              round={12}
            />
            {showDetails && !item.archived && (
              <div style={{ marginTop: '6px', textAlign: 'center' }}>
                <div
                  style={{
                    fontSize: '11px',
                    color: '#94a3b8',
                    marginBottom: '2px',
                  }}>
                  {isActive ? 'Active' : 'Inactive'}
                </div>
                <Switch
                  checked={isActive !== false}
                  onChange={handleToggle}
                  color="primary"
                  size="small"
                />
              </div>
            )}
            {showDetails && item.archived && (
              <div style={{
                fontSize: '11px',
                color: isDark ? '#f59e0b' : '#d97706',
                backgroundColor: isDark ? 'rgba(245,158,11,0.1)' : '#fffbeb',
                padding: '2px 10px',
                borderRadius: '6px',
                marginTop: '6px',
                textAlign: 'center',
                fontWeight: 500,
              }}>
                Archived
              </div>
            )}
            {!showDetails && !isActive && (
              <div
                style={{
                  fontSize: '11px',
                  color: '#94a3b8',
                  backgroundColor: isDark ? 'rgba(255,255,255,0.06)' : '#f8fafc',
                  padding: '2px 8px',
                  borderRadius: '6px',
                  marginTop: '4px',
                  textAlign: 'center',
                }}>
                Inactive
              </div>
            )}
          </div>

          {/* Content */}
          <div style={{ display: 'table-cell', verticalAlign: 'middle', overflow: 'hidden' }}>
            <div
              style={{
                fontWeight: 600,
                fontSize: '14px',
                color: isDark ? '#e2e8f0' : '#0f172a',
                lineHeight: '1.3',
                marginBottom: '4px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}>
              {item.productionInfo && (
                <IProduct size={14} style={{ position: 'relative', top: '2px', marginRight: '4px', color: '#94a3b8' }} />
              )}
              {name}
            </div>
            <StoreItemDetailsFields
              item={item}
              showStore={showStore}
              permissions={permissions}
              showDetails={showDetails}
              showUpdated={showUpdated}
              showFactory={showFactory}
              showId={showId}
              showTransaction={showTransaction}
            />
          </div>

          {/* Quantity + Stock Pill */}
          <div style={{ display: 'table-cell', width: isMobile ? '70px' : (showStockPill ? '155px' : '80px'), verticalAlign: 'middle', textAlign: 'right', paddingRight: '4px' }}>
            {isMobile ? (
              <div style={{ textAlign: 'center' }}>
                <Quantity
                  quantity={quantity}
                  unitLabel={unitLabel}
                  quantitySize={'22px'}
                  enableChangeDirAnimation
                />
                {showStockPill && (
                  <div style={{
                    fontSize: '9px',
                    fontWeight: 600,
                    padding: '1px 6px',
                    borderRadius: '20px',
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                    marginTop: '2px',
                    ...(isOutOfStock ? {
                      color: '#991b1b',
                      backgroundColor: '#fee2e2',
                    } : isLowStock ? {
                      color: '#92400e',
                      backgroundColor: '#fef3c7',
                    } : {
                      color: '#166534',
                      backgroundColor: '#dcfce7',
                    }),
                  }}>
                    {isOutOfStock ? 'Out' : isLowStock ? 'Low' : 'OK'}
                  </div>
                )}
                {renderPackaging()}
                {showBatches && renderBatchInfo()}
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                {showStockPill && (
                  <div style={{
                    fontSize: '10px',
                    fontWeight: 600,
                    padding: '2px 8px',
                    borderRadius: '20px',
                    whiteSpace: 'nowrap',
                    ...(isOutOfStock ? {
                      color: '#991b1b',
                      backgroundColor: '#fee2e2',
                    } : isLowStock ? {
                      color: '#92400e',
                      backgroundColor: '#fef3c7',
                    } : {
                      color: '#166534',
                      backgroundColor: '#dcfce7',
                    }),
                  }}>
                    {isOutOfStock ? 'Out of Stock' : isLowStock ? 'Low Stock' : 'In Stock'}
                  </div>
                )}
                <div style={{ textAlign: 'center', width: '70px', flexShrink: 0 }}>
                  <Quantity
                    quantity={quantity}
                    unitLabel={unitLabel}
                    quantitySize={'28px'}
                    enableChangeDirAnimation
                  />
                  {renderPackaging()}
                  {showBatches && renderBatchInfo()}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showDetails && Array.isArray(products) && products.length > 0 && (
        <div style={{ marginLeft: '76px', marginTop: '8px' }}>
          <div
            style={{ fontSize: '12px', color: '#94a3b8' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <IProduct size={14} />
              <span>
                Used in{' '}
                <span
                  className={'link'}
                  onClick={() => {
                    setOpenStoreItemProducts(true);
                  }}>
                  {products.length} products
                </span>
              </span>
            </div>
            <StoreItemProducts
              open={openStoreItemProducts}
              item={item}
              products={products}
              onClose={() => {
                setOpenStoreItemProducts(false);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
StoreItemDetails.propTypes = {
  item: PropTypes.object,
  showDetails: PropTypes.bool,
  products: PropTypes.array,
  onGroupsCountClick: PropTypes.func,
  showStore: PropTypes.bool,
  showTransaction: PropTypes.bool,
  showBatches: PropTypes.bool,
  showUpdated: PropTypes.bool,
  showFactory: PropTypes.bool,
  showId: PropTypes.bool,
  onToggleActive: PropTypes.func,
};

StoreItemDetails.defaultProps = {
  showDetails: false,
  showStore: true,
  showTransaction: true,
  showBatches: true,
  showUpdated: false,
  permissions: {},
  showFactory: false,
  showId: false,
  onToggleActive: (itemId, isActive) => {
    console.log(
      `Toggling item ${itemId} to ${isActive ? 'active' : 'inactive'}`
    );
    toast.success(
      `Item ${isActive ? 'activated' : 'deactivated'} successfully`
    );
  },
};
export default StoreItemDetails;
